import React from 'react'

import './ProgressBar.scss'

export const ProgressBar = ({ percent = 0 }) => {
  return (
    <div className="progressbar-container">
      <div className="progress-indicator" style={{ width: `${ percent }%` }}></div>
    </div>
  )
}